import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import "../styles/questionCard.css";

const QuestionCard = ({
  questionIndex,
  statements,
  handleOptionChange,
  selectedOptions,
}) => {
  const [localSelectedOptions, setLocalSelectedOptions] = useState({});

  useEffect(() => {
    const questionSelectedOptions = Object.fromEntries(
      Object.entries(selectedOptions).filter(
        ([_, option]) => option.questionIndex === questionIndex
      )
    );
    setLocalSelectedOptions(questionSelectedOptions);
  }, [selectedOptions, questionIndex]);

  const handleOptionInternalChange = (statementId, value, category) => {
    setLocalSelectedOptions((prev) => {
      const newOptions = { ...prev };

      // Ensure only one "yes" and one "no" per question
      Object.keys(newOptions).forEach((key) => {
        if (newOptions[key].value === value) {
          delete newOptions[key];
        }
      });

      newOptions[statementId] = { value, category, questionIndex };

      return newOptions;
    });

    // Call handleOptionChange after setting local state
    handleOptionChange(questionIndex, statementId, value, category);
  };

  return (
    <Card className="card-question">
      <Card.Body>
        <Card.Title className="head-card-txt text-center my-4">
          Pilih yang paling sesuai dan paling tidak sesuai dalam diri anda
        </Card.Title>
        {statements.map((statement) => (
          <div key={statement.id} className="statement-item mb-3">
            <div className="radio-container">
              <input
                type="radio"
                id={`yes-${statement.id}`}
                name={`option-${statement.id}`}
                value="yes"
                checked={localSelectedOptions[statement.id]?.value === "yes"}
                onChange={() =>
                  handleOptionInternalChange(
                    statement.id,
                    "yes",
                    statement.category_yes
                  )
                }
              />
              <label htmlFor={`yes-${statement.id}`} className="yes-label">
                <i className="bi bi-check-lg"></i>
              </label>

              <div className="statement-text">
                <p>{statement.statement_text}</p>
              </div>

              <input
                type="radio"
                id={`no-${statement.id}`}
                name={`option-${statement.id}`}
                value="no"
                checked={localSelectedOptions[statement.id]?.value === "no"}
                onChange={() =>
                  handleOptionInternalChange(
                    statement.id,
                    "no",
                    statement.category_no
                  )
                }
              />
              <label htmlFor={`no-${statement.id}`} className="no-label">
                <i className="bi bi-x-lg"></i>
              </label>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default QuestionCard;
